// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "f33e8355b9ce3128bf472b0e0d8b25b802520f8a/static/css/" + chunkId + "." + {"252":"3d0d1673","725":"84c1fc5e","854":"36854e5e"}[chunkId] + ".chunk.css";
};